import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Input, Label } from 'reactstrap';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function DailyAutomation() {
  const [btcImages, setBtcImages] = useState('');
  const [briefingImages, setBriefingImages] = useState('');
  const [btcVideoPath, setBtcVideoPath] = useState('');
  const [briefingVideoPath, setBriefingVideoPath] = useState('');
  const [publishResult, setPublishResult] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/api/video/videos`);
        setRecent(res.data);
      } catch {}
    };
    load();
  }, [publishResult]);

  const parseList = (txt) => txt.split(/\r?\n/).map(s => s.trim()).filter(Boolean);

  const generateBtc = async () => {
    const images = parseList(btcImages);
    const res = await axios.post(`${API}/api/video/generate/btc`, { images });
    setBtcVideoPath(res.data.videoPath);
  };

  const generateBriefing = async () => {
    const lines = parseList(briefingImages);
    const assets = { ETH: [], XRP: [], SPY: [] };
    for (const line of lines) {
      const [asset, img] = line.split('|').map(s => s.trim());
      if (assets[asset]) assets[asset].push(img);
    }
    const res = await axios.post(`${API}/api/video/generate/briefing`, { imagesByAsset: assets });
    setBriefingVideoPath(res.data.videoPath);
  };

  const publish = async (filePath, title, description, privacy) => {
    const res = await axios.post(`${API}/api/video/publish`, { filePath, title, description, privacyStatus: privacy });
    setPublishResult(res.data);
  };

  return (
    <Container fluid className="mt-3">
      <Row>
        <Col md={6}>
          <Card>
            <CardBody>
              <h5>BTC Daily YouTube Video (Public)</h5>
              <Label>Image paths (one per line)</Label>
              <Input type="textarea" rows={6} value={btcImages} onChange={e => setBtcImages(e.target.value)} placeholder="c:\\path\\disclaimer.png\nc:\\path\\today.png\n..."/>
              <div className="d-flex gap-2 mt-2">
                <Button color="primary" onClick={generateBtc}>Generate Video</Button>
                {btcVideoPath && <Button color="success" onClick={() => publish(btcVideoPath, 'BTC Daily Forecast', 'Daily BTC AI forecast video', 'public')}>Publish Public</Button>}
              </div>
              {btcVideoPath && <div className="mt-2"><b>Video:</b> {btcVideoPath}</div>}
            </CardBody>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <CardBody>
              <h5>The Daily AI Briefing (Private)</h5>
              <p>Enter lines like: ETH|c:\\path\\img1.png</p>
              <Input type="textarea" rows={6} value={briefingImages} onChange={e => setBriefingImages(e.target.value)} placeholder="ETH|c:\\path\\eth1.png\nXRP|c:\\path\\xrp1.png\nSPY|c:\\path\\spy1.png"/>
              <div className="d-flex gap-2 mt-2">
                <Button color="primary" onClick={generateBriefing}>Generate Video</Button>
                {briefingVideoPath && <Button color="warning" onClick={() => publish(briefingVideoPath, 'Daily AI Briefing', 'ETH/XRP/SPY private video for members', 'private')}>Publish Private</Button>}
              </div>
              {briefingVideoPath && <div className="mt-2"><b>Video:</b> {briefingVideoPath}</div>}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {publishResult && (
        <Row className="mt-3">
          <Col>
            <Card><CardBody>
              <h6>Publish Result</h6>
              <pre className="mb-0">{JSON.stringify(publishResult, null, 2)}</pre>
            </CardBody></Card>
          </Col>
        </Row>
      )}
      <Row className="mt-3">
        <Col>
          <Card>
            <CardBody>
              <h6>Recent Videos</h6>
              <ul>
                {recent.map(v => (
                  <li key={v.id}>
                    <b>{v.type}</b> - {v.title} {v.youtube_video_id ? ` (YouTube: ${v.youtube_video_id})` : ''}
                  </li>
                ))}
              </ul>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
